import {
  SET_WAREHOUSE_LIST,
  ADD_GEOFENCE_WITH_UPDATED_WAREHOUSES,
  SET_WAREHOUSE_SEARCH,
  SET_VISIBLE_WAREHOUSE_LIST,
  VIEW_ASSIGNED_WAREHOUSE,
  SET_DRAWING_OPTS,
  SET_BOUNDS,
  TOGGLE_LOADING,
  ADD_GEOFENCES,
  SET_NEW_CITY_NAME,
  SET_TO_PUBLISH_FENCE,
  SET_TO_PUBLISH_FENCE_CATEGORY,
  SET_TO_PUBLISH_FENCE_NAME,
  SET_MAP_ZOOM,
  SET_MAP_CENTER,
  SET_SELECTED_VERTEX,
  SET_NEW_CITY_BOUNDS,
  ERROR_TOAST_MESSAGE,
  SUCCESS_TOAST_MESSAGE,
  SET_CITY_NAME,
  SET_AVAILABLE_CITIES,
  SET_LOADER,
  SET_GEOFENCES,
  SET_VISIBLE_GEOFENCES,
  ADD_JUST_PUBLISHED_GEOFENCE,
  SET_SELECTED_POLYGON_ID,
  EDIT_SELECTED_ID_FENCE,
  CANCEL_EDIT_FENCE,
  CANCEL_CREATE_FENCE,
  REMOVE_SELECTED_ID_FENCE,
  ADD_CATEGORY_TO_FILTER,
  REMOVE_CATEGORY_FROM_FILTER,
  SET_SEARCH_QUERY_FILTER,
  SET_ORDER_PINS,
  ADD_VISIBLE_LAYER,
  REMOVE_VISIBLE_LAYER,
  SET_USER_AUTHENTICATED,
  SET_REPLAY_ON_AUTH,
  SET_ORDER_PINS_DATE_RANGE,
  SET_30_DAYS_DATE_RANGE,
  VIEW_ASSIGNED_BUDDIES,
  SET_ASSIGNED_BUDDIES,
  ADD_ADDITIONAL_CITY_GEOFENCES,
  REMOVE_ADDITIONAL_CITY_GEOFENCES
} from "./actions";
import { polygonToGoogleMapBounds } from "../../api/geofence/utils";
import { geofenceInitialState } from "./initial-state";

import { createIndex } from "../../utils/order-count-fence";

const FlexSearch = require("flexsearch");
const index = new FlexSearch("match");

function filterGeofences(geofences, filterState, searchIndex) {
  let result = geofences;
  let searchResults = null;
  if (filterState.searchQuery) {
    searchResults = searchIndex.search({
      query: filterState.searchQuery,
      suggest: false
    });
  }
  if (searchResults) {
    const set = new Set(searchResults);
    result = result.filter(e => set.has(e._id));
  }
  result = result.filter(e =>
    filterState.categoriesToShow !== null
      ? filterState.categoriesToShow.indexOf(e.properties.fenceCategory) !== -1
      : true
  );
  return result;
}

function indexGeofences(geofences, searchIndex) {
  if (!geofences || geofences.length === 0) {
    return;
  }
  geofences.forEach(e => {
    searchIndex.add(e._id, e.properties.name);
  });
}

function removeGeofenceIndex(geofence, searchIndex) {
  if (!geofence) {
    return;
  }
  searchIndex.remove(geofence._id);
}

function addGeofenceIndex(geofence, searchIndex) {
  if (!geofence) {
    return;
  }
  searchIndex.add(geofence._id, geofence.properties.name);
}

function updateGeofenceIndex(geofence, searchIndex) {
  if (!geofence) {
    return;
  }
  searchIndex.update(geofence._id, geofence.properties.name);
}

export const geofenceReducer = (state = geofenceInitialState, action) => {
  switch (action.type) {
    case VIEW_ASSIGNED_WAREHOUSE:
      return {
        ...state,
        viewAssignedWarehousesOf: action.payload
      };
    case SET_WAREHOUSE_LIST:
      return {
        ...state,
        warehouseList: action.payload
          ? action.payload.filter(
              e => e.city.toLowerCase() === state.currentCityName.toLowerCase()
            )
          : action.payload
      };
    case SET_VISIBLE_WAREHOUSE_LIST:
      return {
        ...state,
        visibleWarehouseList: action.payload
          ? action.payload.filter(
              e => e.city.toLowerCase() === state.currentCityName.toLowerCase()
            )
          : action.payload
      };
    case SET_WAREHOUSE_SEARCH:
      return {
        ...state,
        warehouseSearchQuery: action.payload
      };
    case SET_USER_AUTHENTICATED:
      return {
        ...state,
        userAuthenticated: action.payload
      };
    case SET_REPLAY_ON_AUTH:
      return {
        ...state,
        replayActionOnAuthentication: [
          ...state.replayActionOnAuthentication,
          action.payload
        ]
      };
    case SET_MAP_CENTER:
      return {
        ...state,
        mapCenter: action.payload
      };
    case SET_MAP_ZOOM:
      return {
        ...state,
        mapZoom: action.payload
      };
    case SET_SELECTED_VERTEX:
      return {
        ...state,
        selectedVertex: action.payload
      };
    case SET_ORDER_PINS:
      if (action.payload) {
        createIndex(action.payload);
      }
      return {
        ...state,
        orderpins: action.payload
      };

    case VIEW_ASSIGNED_BUDDIES:
      return {
        ...state,
        viewAssignedBuddiesOf: action.payload,
        assignedBuddies: null
      };

    case SET_ASSIGNED_BUDDIES:
      return {
        ...state,
        assignedBuddies: action.payload
      };

    case SET_ORDER_PINS_DATE_RANGE:
      return {
        ...state,
        orderpinsFilter: {
          ...state.orderpinsFilter,
          last30Days: false,
          dateRange: action.payload
        }
      };

    case SET_30_DAYS_DATE_RANGE:
      return {
        ...state,
        orderpinsFilter: {
          ...state.orderpinsFilter,
          last30Days: action.payload
        }
      };

    case SET_SELECTED_POLYGON_ID:
      if (!action.payload) {
        return {
          ...state,
          selectedPolygonId: null
        };
      }
      return {
        ...state,
        selectedPolygonId: action.payload,
        viewAssignedBuddiesOf:
          state.viewAssignedBuddiesOf === action.payload
            ? action.payload
            : null,
        viewAssignedWarehousesOf:
          state.viewAssignedWarehousesOf === action.payload
            ? action.payload
            : null,
        bounds: polygonToGoogleMapBounds(
          state.geofences.find(e => e._id === action.payload).geometry
        )
      };
    case EDIT_SELECTED_ID_FENCE:
      if (!state.selectedPolygonId) {
        return state;
      }
      const geofencesWithoutSelectedFence = state.visibleGeofences.filter(
        e => e._id !== state.selectedPolygonId
      );

      return {
        ...state,
        visibleGeofences: geofencesWithoutSelectedFence,
        toPublishFence: state.geofences.find(
          e => e._id === state.selectedPolygonId
        )
      };
    case REMOVE_VISIBLE_LAYER:
      return {
        ...state,
        visibleLayers: state.visibleLayers.filter(e => e !== action.payload)
      };

    case ADD_VISIBLE_LAYER:
      return {
        ...state,
        visibleLayers: [
          ...state.visibleLayers.filter(e => e !== action.payload),
          action.payload
        ]
      };

    case REMOVE_SELECTED_ID_FENCE:
      if (!state.selectedPolygonId) {
        return state;
      }
      removeGeofenceIndex(
        state.geofences.find(e => e._id === state.selectedPolygonId),
        index
      );
      return {
        ...state,
        visibleGeofences: state.visibleGeofences.filter(
          e => e._id !== state.selectedPolygonId
        ),
        geofences: state.geofences.filter(
          e => e._id !== state.selectedPolygonId
        ),
        selectedPolygonId: null
      };
    case CANCEL_EDIT_FENCE:
      if (!state.selectedPolygonId) {
        return state;
      }
      return {
        ...state,
        visibleGeofences: [
          ...state.visibleGeofences,
          state.geofences.find(e => e._id === state.selectedPolygonId)
        ],
        selectedPolygonId: null,
        toPublishFence: null
      };

    case SET_TO_PUBLISH_FENCE:
      return {
        ...state,
        toPublishFence: action.payload,
        drawingOpts: null
      };
    case ADD_CATEGORY_TO_FILTER:
      let newAddedFilter;
      if (state.filter.categoriesToShow === null) {
        newAddedFilter = {
          ...state.filter,
          categoriesToShow: [action.payload]
        };
        return {
          ...state,
          filter: newAddedFilter,
          visibleGeofences: filterGeofences(
            state.geofences,
            newAddedFilter,
            index
          )
        };
      }
      if (state.filter.categoriesToShow.indexOf(action.payload) !== -1) {
        return state;
      }
      newAddedFilter = {
        ...state.filter,
        categoriesToShow: [...state.filter.categoriesToShow, action.payload]
      };

      return {
        ...state,
        filter: newAddedFilter,
        visibleGeofences: filterGeofences(
          state.geofences,
          newAddedFilter,
          index
        )
      };
    case REMOVE_CATEGORY_FROM_FILTER:
      if (state.filter.categoriesToShow === null) {
        return state;
      }
      if (state.filter.categoriesToShow.indexOf(action.payload) === -1) {
        return state;
      }
      let removedCategoryArr = state.filter.categoriesToShow.filter(
        e => e !== action.payload
      );
      let filterWithRemovedCategory = {
        ...state.filter,
        categoriesToShow:
          removedCategoryArr.length === 0 ? null : removedCategoryArr
      };
      return {
        ...state,
        filter: filterWithRemovedCategory,
        visibleGeofences: filterGeofences(
          state.geofences,
          filterWithRemovedCategory,
          index
        )
      };

    case SET_SEARCH_QUERY_FILTER:
      const filterWithSearchQuery = {
        ...state.filter,
        searchQuery: action.payload
      };
      return {
        ...state,
        filter: filterWithSearchQuery,
        visibleGeofences: filterGeofences(
          state.geofences,
          filterWithSearchQuery,
          index
        )
      };

    case SET_TO_PUBLISH_FENCE_CATEGORY:
      if (!state.toPublishFence) {
        return state;
      }
      return {
        ...state,
        toPublishFence: {
          ...state.toPublishFence,
          properties: {
            ...state.toPublishFence.properties,
            fenceCategory: action.payload
          }
        }
      };
    case SET_TO_PUBLISH_FENCE_NAME:
      if (!state.toPublishFence) {
        return state;
      }
      return {
        ...state,
        toPublishFence: {
          ...state.toPublishFence,
          properties: {
            ...state.toPublishFence.properties,
            name: action.payload
          }
        }
      };
    case CANCEL_CREATE_FENCE:
      return {
        ...state,
        toPublishFence: null,
        drawingOpts: null
      };
    case SET_DRAWING_OPTS:
      const { drawingMode, fenceCategory, editable } = action.payload;
      return {
        ...state,
        drawingOpts: {
          drawingMode,
          fenceCategory,
          editable
        }
      };
    case SET_NEW_CITY_NAME:
      return { ...state, currentCityName: "", newCityName: action.payload };
    case SET_LOADER:
      // 0 means dont show loader and > 0 means show loader.
      // Done this algo to handle loading triggered by multiple
      // async API calls
      if (action.payload) {
        return {
          ...state,
          showLoaderModal: state.showLoaderModal + 1
        };
      }
      return { ...state, showLoaderModal: state.showLoaderModal - 1 };
    case SET_CITY_NAME:
      return { ...state, newCityName: "", currentCityName: action.payload };
    case SET_AVAILABLE_CITIES:
      return { ...state, availableCities: action.payload };
    case SET_BOUNDS:
      return {
        ...state,
        bounds: action.payload
      };

    // TODO: try a better way to reset view when city changes.
    case SET_GEOFENCES:
      indexGeofences(action.payload, index);
      return {
        ...state,
        geofences: action.payload,
        visibleGeofences: action.payload,
        additionalGeofences: {},
        filter: geofenceInitialState.filter,
        selectedPolygonId: null,
        toPublishFence: null,
        orderpins: [],
        viewAssignedBuddiesOf: null,
        viewAssignedWarehousesOf: null,
        drawingOpts: null
      };
    case SET_VISIBLE_GEOFENCES:
      return {
        ...state,
        visibleGeofences: action.payload
      };
    case ADD_GEOFENCE_WITH_UPDATED_WAREHOUSES:
      const updated = [
        ...state.geofences.filter(e => e._id !== action.payload._id),
        action.payload
      ];
      return {
        ...state,
        geofences: updated,
        visibleGeofences: updated,
        toPublishFence: null,
        filter: geofenceInitialState.filter,
        selectedPolygonId: null,
        viewAssignedWarehousesOf: null
      };

    case ADD_JUST_PUBLISHED_GEOFENCE:
      if (state.geofences.find(e => action.payload._id)) {
        addGeofenceIndex(action.payload, index);
      } else {
        updateGeofenceIndex(action.payload, index);
      }
      const updatedGeofences = [
        ...state.geofences.filter(e => e._id !== action.payload._id),
        action.payload
      ];
      return {
        ...state,
        geofences: updatedGeofences,
        visibleGeofences: updatedGeofences,
        toPublishFence: null,
        filter: geofenceInitialState.filter,
        selectedPolygonId: null
      };
    case SET_NEW_CITY_BOUNDS:
      return {
        ...state,
        cityBounds: action.payload
      };
    case TOGGLE_LOADING:
      let { loading } = state;
      if (!loading) {
        loading = true;
      } else {
        loading = false;
      }
      return {
        ...state,
        showLoaderModal: loading
      };
    case ADD_GEOFENCES:
      let { geofences } = action.payload;
      indexGeofences(geofences, index);
      return {
        ...state,
        geofences
      };
    case ADD_ADDITIONAL_CITY_GEOFENCES:
      return {
        ...state,
        additionalGeofences: {
          ...state.additionalGeofences,
          [action.payload.cityName]: action.payload.geofences
        },
        visibleGeofences: filterGeofences(
          [...state.visibleGeofences, ...action.payload.geofences],
          state.filter,
          index
        ),
        geofences: [...state.geofences, ...action.payload.geofences]
      };
    case REMOVE_ADDITIONAL_CITY_GEOFENCES:
      let fencesToRemove = [];
      const newAdditionalGeofencesObj = { ...state.additionalGeofences };
      action.payload.forEach(cityName => {
        fencesToRemove = [
          ...fencesToRemove,
          ...state.additionalGeofences[cityName]
        ];
        delete newAdditionalGeofencesObj[cityName];
      });
      console.log(fencesToRemove);
      return {
        ...state,
        additionalGeofences: newAdditionalGeofencesObj,
        visibleGeofences: filterGeofences(
          state.visibleGeofences.filter(
            e => fencesToRemove.find(f => f._id === e._id) === undefined
          ),
          state.filter,
          index
        ),
        geofences: state.geofences.filter(
          e => fencesToRemove.find(f => f._id === e._id) === undefined
        )
      };
    case ERROR_TOAST_MESSAGE:
      return {
        ...state,
        errorToastMessage: { msg: action.payload }
      };
    case SUCCESS_TOAST_MESSAGE:
      return {
        ...state,
        successToastMessage: { msg: action.payload }
      };
    default:
      return state;
  }
};
